import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type TimeFrame = '1m' | '5m' | '15m' | '1h' | '4h' | '1D';

interface TradingFormState {
  // Broker & instrument selection
  selectedBroker: string;
  selectedFuture: string;
  searchQuery: string;

  // Chart settings
  timeframe: TimeFrame;

  // Strategy configuration
  strategyId: string;
  capital: string;
  stopLoss: string;
  takeProfit: string;

  // Grid Bot parameters
  gridSize: string;
  priceRange: string;
  orderQuantity: string;
  updateInterval: string;
  minProfit: string;

  // Actions
  setSelectedBroker: (v: string) => void;
  setSelectedFuture: (v: string) => void;
  setSearchQuery: (v: string) => void;
  setTimeframe: (v: TimeFrame) => void;
  setStrategyId: (v: string) => void;
  setCapital: (v: string) => void;
  setStopLoss: (v: string) => void;
  setTakeProfit: (v: string) => void;
  setGridSize: (v: string) => void;
  setPriceRange: (v: string) => void;
  setOrderQuantity: (v: string) => void;
  setUpdateInterval: (v: string) => void;
  setMinProfit: (v: string) => void;
}

export const useTradingStore = create<TradingFormState>()(
  persist(
    (set) => ({
      selectedBroker: '',
      selectedFuture: '',
      searchQuery: '',
      timeframe: '1h' as TimeFrame,
      strategyId: 'grid_bot',
      capital: '10000',
      stopLoss: '5',
      takeProfit: '10',
      gridSize: '10',
      priceRange: '5',
      orderQuantity: '1',
      updateInterval: '60',
      minProfit: '0.5',

      setSelectedBroker: (v) => set({ selectedBroker: v }),
      setSelectedFuture: (v) => set({ selectedFuture: v }),
      setSearchQuery: (v) => set({ searchQuery: v }),
      setTimeframe: (v) => set({ timeframe: v }),
      setStrategyId: (v) => set({ strategyId: v }),
      setCapital: (v) => set({ capital: v }),
      setStopLoss: (v) => set({ stopLoss: v }),
      setTakeProfit: (v) => set({ takeProfit: v }),
      setGridSize: (v) => set({ gridSize: v }),
      setPriceRange: (v) => set({ priceRange: v }),
      setOrderQuantity: (v) => set({ orderQuantity: v }),
      setUpdateInterval: (v) => set({ updateInterval: v }),
      setMinProfit: (v) => set({ minProfit: v }),
    }),
    {
      name: 'trading-form-storage',
      // Only persist the form values, not functions
      partialize: (state) => ({
        selectedBroker: state.selectedBroker,
        selectedFuture: state.selectedFuture,
        searchQuery: state.searchQuery,
        timeframe: state.timeframe,
        strategyId: state.strategyId,
        capital: state.capital,
        stopLoss: state.stopLoss,
        takeProfit: state.takeProfit,
        gridSize: state.gridSize,
        priceRange: state.priceRange,
        orderQuantity: state.orderQuantity,
        updateInterval: state.updateInterval,
        minProfit: state.minProfit,
      }),
    }
  )
);
